import { render, staticRenderFns } from "./title.vue?vue&type=template&id=c72db360&scoped=true&"
import script from "./title.vue?vue&type=script&lang=js&"
export * from "./title.vue?vue&type=script&lang=js&"
import style0 from "./title.vue?vue&type=style&index=0&id=c72db360&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72db360",
  null
  
)

export default component.exports